document.querySelectorAll(".guide__category-item").forEach((item) => {
  console.log(item);
  item.addEventListener("click", () => {
    this.onScrollTo(item.dataset.id);
  });
});

function onScrollTo(id) {
  const element = document.getElementById(id);
  element.scrollIntoView({ behavior: "smooth" });
}
